import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Output } from '@angular/core';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router } from '@angular/router';
import { forEach } from 'jszip';
import { Observable, timer } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-typeahead-textbox',
  templateUrl: './typeahead-textbox.component.html',
  styleUrls: ['./typeahead-textbox.component.css']
})
export class TypeaheadTextboxComponent implements OnInit, OnChanges {

  @Input() allValues: any[];
  @Input() values: any[];
  @Input() placehold: any;
  @Input() isApi?: boolean = false;
  @Input() disable?: boolean = false;
  @Input() limitedSelection?: boolean = false;
  @Output() emittedValues = new EventEmitter<any>();
  @Output() searchText = new EventEmitter<String>();
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  textcontrol = new UntypedFormControl();
  filteredValues: any = [];
  @ViewChild('inputText') inputText: ElementRef<HTMLInputElement>;
  @ViewChild('tech') matAutocomplete: MatAutocomplete;

  constructor(private ref: ChangeDetectorRef) {

  }
  ngOnInit() {
    if (this.disable) {
      this.textcontrol.disable();
      this.removable = false;
    }
    this.values = this.values?.length > 0 ? this.values : [];
    const removedItems: any[] = [];


    if (this.values.length > 0) {

      this.values.forEach(item => {

        const index = this.allValues.indexOf(item);

        if (index >= 0) {
          removedItems.push(this.allValues.splice(index, 1)[0]);

        }
      })
    }
    this.allValues.push(...removedItems);
    this.filteredValues = this.allValues;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.disable) {
      this.textcontrol.disable();
      this.removable = false;
    }
    else {
      this.removable = true;
    }
    if (this.values && this.allValues && this.values.length > 0) {
      this.values.forEach(item => {
        this.allValues = this.allValues.filter(x => x.name != item.name);
      });

    }
    this.filteredValues = this.allValues;
  }
  selectionChange(value) {
    if (this.isApi) {
      this.searchText.emit(value);
    }
    else {
      this.filteredValues = this.allValues.filter(x => (x.name.toLowerCase().includes(value.toLowerCase())));
    }
  }
  getPlaceHolder() {
    return this.placehold;
  }
  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if (this.allValues.indexOf(value.trim()) >= 0 && this.values.indexOf(value.trim()) == -1) {
        this.values.push(value.trim());
        const index = this.allValues.indexOf(value.trim());

        if (index >= 0) {
          this.allValues.splice(index, 1);
        }
      }
      if (input) {
        input.value = '';
      }
      this.textcontrol.setValue(null);
    }
  }

  remove(value: string): void {
    const index = this.values.indexOf(value);

    if (index >= 0) {
      this.values.splice(index, 1);
      this.allValues.push(value)
      this.emittedValues.emit(this.values);
    }
  }

  selected(event: MatAutocompleteSelectedEvent, value): void {
    this.values = this.values ? this.values : [];
    if (this.allValues.indexOf(value) >= 0 && this.values && this.values.indexOf(value) == -1) {

      const index = this.allValues.indexOf(value);
      const removedValue = this.allValues.splice(index, 1)[0];
      this.values.push(removedValue);

    }
    this.inputText.nativeElement.value = '';
    this.textcontrol.setValue(null);
    this.emittedValues.emit(this.values)
  }
}
